var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 13.515C3.31767 13.515 0.333008 10.5303 0.333008 6.84831C0.333008 3.16631 3.31767 0.181641 6.99967 0.181641C10.6817 0.181641 13.6663 3.16631 13.6663 6.84831C13.6663 10.5303 10.6817 13.515 6.99967 13.515ZM6.99967 12.1816C8.41416 12.1816 9.77072 11.6197 10.7709 10.6195C11.7711 9.61935 12.333 8.2628 12.333 6.84831C12.333 5.43382 11.7711 4.07727 10.7709 3.07707C9.77072 2.07688 8.41416 1.51497 6.99967 1.51497C5.58519 1.51497 4.22863 2.07688 3.22844 3.07707C2.22824 4.07727 1.66634 5.43382 1.66634 6.84831C1.66634 8.2628 2.22824 9.61935 3.22844 10.6195C4.22863 11.6197 5.58519 12.1816 6.99967 12.1816ZM6.33501 9.51497L3.50634 6.68631L4.44901 5.74364L6.33501 7.62964L10.1057 3.85831L11.049 4.80097L6.33501 9.51497Z",
    fill: "#3AA64C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.bd48834540d26446792c1993cc23b031.svg";
export { ForwardRef as ReactComponent };